// ============================================
// COSMIC HINDU - App Router
// ============================================

import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '@context/AuthContext';

// Store Pages
import StoreLayout from '@components/layout/StoreLayout';
import HomePage from '@pages/store/HomePage';
import ShopPage from '@pages/store/ShopPage';
import ProductPage from '@pages/store/ProductPage';
import CartPage from '@pages/store/CartPage';
import CheckoutPage from '@pages/store/CheckoutPage';
import OrderSuccessPage from '@pages/store/OrderSuccessPage';
import AboutPage from '@pages/store/AboutPage';
import ContactPage from '@pages/store/ContactPage';
import CustomerLogin from '@pages/store/CustomerLogin';
import CustomerDashboard from '@pages/store/CustomerDashboard';

// Admin Pages
import AdminLayout from '@pages/admin/AdminLayout';
import AdminLogin from '@pages/admin/LoginPage';
import Dashboard from '@pages/admin/Dashboard';
import OrdersManager from '@pages/admin/OrdersManager';
import ProductsManager from '@pages/admin/ProductsManager';
import InventoryPage from '@pages/admin/InventoryPage';
import Discounts from '@pages/admin/Discounts';
import CustomersManager from '@pages/admin/CustomersManager';
import Analytics from '@pages/admin/Analytics';
import Settings from '@pages/admin/Settings';

// Protected Admin Route
function ProtectedRoute({ children }) {
  const { isAuthenticated } = useAuth();
  if (!isAuthenticated) return <Navigate to="/admin/login" replace />;
  return children;
}

// Protected Customer Route
function CustomerRoute({ children }) {
  const token = localStorage.getItem('customer_token');
  if (!token) return <Navigate to="/account" replace />;
  return children;
}

export default function App() {
  return (
    <Routes>
      {/* ── Store Routes ── */}
      <Route element={<StoreLayout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/shop" element={<ShopPage />} />
        <Route path="/shop/:categoryId" element={<ShopPage />} />
        <Route path="/product/:productId" element={<ProductPage />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/order-success" element={<OrderSuccessPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        {/* Customer Auth */}
        <Route path="/account" element={<CustomerLogin />} />
        <Route path="/account/dashboard" element={<CustomerRoute><CustomerDashboard /></CustomerRoute>} />
      </Route>

      {/* ── Admin Routes ── */}
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route
        path="/admin"
        element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}
      >
        <Route index element={<Dashboard />} />
        <Route path="orders" element={<OrdersManager />} />
        <Route path="products" element={<ProductsManager />} />
        <Route path="inventory" element={<InventoryPage />} />
        <Route path="discounts" element={<Discounts />} />
        <Route path="customers" element={<CustomersManager />} />
        <Route path="analytics" element={<Analytics />} />
        <Route path="settings" element={<Settings />} />
      </Route>

      {/* 404 */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
